import { useEffect } from "react";
import { scheduleClarity } from "@/lib/clarity";

export default function ClarityBootstrap() {
  useEffect(() => { scheduleClarity(); }, []);
  return null;
}